export default __webpack_public_path__ + "static/media/FB-Logo.b78b416e.svg";